import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Projection from '../../entities/casis/projection'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface ProjectionState extends ListState<Projection>{
    editModel: Projection;
    dealers: Array<any>;
    reportList: Array<any>;
    activeList: Array<Projection>;
}
class ProjectionModule extends ListModule<ProjectionState,any,Projection>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Projection>(),
        loading: false,
        editModel: new Projection(),
        activeList: new Array<Projection>(),
        reportList: new Array<any>(),
        dealers: new Array<any>(),
        path: 'projections'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions
        async getAll(context: ActionContext<ProjectionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/' + (context.state as any).path, { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            context.state.totalCount = reponse.data.result.length;
            context.state.list = reponse.data.result;
        },
        async create(context: ActionContext<ProjectionState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.post('/api/' + (context.state as any).path, payload.data).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false; 
            return response.data.result;
        },
        async export(context: ActionContext<ProjectionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/projections/export', { params: payload.data }).catch(e => {
                context.state.loading = false;
                return Promise.reject(e);
            });
            context.state.loading = false;
            return reponse.data.result.filename;
        },
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
        edit(state: ProjectionState, model: Projection) {
            state.editModel = model;
            
        }, 
        new(state: ProjectionState, model: Projection) {
            state.editModel = Object.assign({});
        },
    });
}
const projectionModule=new ProjectionModule();
export default projectionModule;
